import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Card, Col, Row } from 'react-bootstrap';
import { Trans } from 'react-i18next';
import { ProductContext } from 'context/Context';

const OrderInfo = ({ order }) => {
  const {
    productsState: {
      config: { currency }
    }
  } = useContext(ProductContext);

  return (
    <Card className="mb-3">
      <Card.Body>
        <Row>
          <Col md={6} lg={4} className="mb-4 mb-lg-0">
            <h5 className="mb-3 fs-0">
              <Trans ns="commerce">Amount</Trans>
            </h5>
            <h6 className="mb-2">
              <Trans ns="commerce">Total</Trans>:{currency}
              {order.amount}
            </h6>
          </Col>
          <Col md={6} lg={4} className="mb-4 mb-lg-0">
            <h5 className="mb-3 fs-0">
              <Trans ns="commerce">Shipping Address</Trans>
            </h5>
            <h6 className="mb-2">{order.addressName}</h6>
            <p className="mb-0 fs--1">{order.addressStreet}</p>
            <div className="text-500 fs--1">{order.addressPhone}</div>
          </Col>
          <Col md={6} lg={4}>
            <h5 className="mb-3 fs-0">
              <Trans ns="commerce">Payment Method</Trans>
            </h5>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

OrderInfo.propTypes = {
  order: PropTypes.object
};

export default OrderInfo;
